
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card">
      <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

        <div class="row">
          <div class="col-print-12 text-align-center">
            <label class="margin-bottom-10px font-familyhead">Daily Work Book</label>
          </div>
        </div>
        
        <div class="col-print-12">
          <div class="row bordertop margin-right-0px">
            <div class="col-print-6"></div>
            <div class="col-print-6 text-align-end">
              <label class="margin-bottom-0px font-family font-weight-normal" *ngIf="SelectedFromDate">Date: {{SelectedDateNew| date:'MMM-dd-yyyy'}}</label>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero border4">
                    <thead>
                      <tr>

                        <!--<th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-150px text-align-center">
    Date
  </th>-->
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family width-35px padding-right-0px padding-left-0px">
                          #
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family padding-left-0px padding-right-0px">
                          Patient Name
                        </th>
                        <!--<th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family width-150px">
    Branch
  </th>-->
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Plan Name
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Time
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Mode
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Status
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Created By
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Assigned To
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Remarks
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentCounsellingActivitiesByTimeController ; let RowIndex = index ">
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-center">
    <label class="margin-bottom-0px label-table-color"> {{l.ActivityDate| date:'MMM-dd-yyyy'}}</label>
  </td>-->
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center padding-right-0px padding-left-0px">
                          {{RowIndex+1}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left padding-right-0px padding-left-0px">
                          {{l.DisplayName}}
                        </td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-center">
    {{l.FacilityShortName}}
  </td>-->
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.PlanName}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                          {{l.ActivityTime}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                          <div [ngSwitch]="l.FollowupMode">
                            <div *ngSwitchCase="'Email'" class="">
                              <i class="fa fa-envelope "></i>
                            </div>
                            <div *ngSwitchCase="'Phone'" class="">
                              <i class="fas fa-mobile-alt"></i>
                            </div>
                            <div *ngSwitchCase="'Visit'" class="">
                              <i class="fa fa-handshake"></i>
                            </div>
                            <div *ngSwitchCase="'Other'" class="">
                              <label>{{l.FollowupMode}}</label>
                            </div>
                          </div>
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.FollowupStatus}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.CreatedUser}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          {{l.AssignedToName}}
                        </td>
                        <td class="font-family padding-top-2px td-elipsis padding-bottom-2px text-align-left">
                          {{l.Remarks}}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
